import { getRequestListLight } from '../../../../api'
import {
  ButtonAsyncSelect as ButtonAsyncSelectComponent,
  ButtonSelectControl,
} from '../../../Select'
import { Container } from '../../Container'
import { useSelectState } from '../Selects.hooks'
import { toRequestAsyncSelectItems } from '../Selects.utils'

import ServiceRequestIcon from '../../../../icons/service-request.svg'

function ButtonAsyncSelect() {
  const { handleClear, handleSelectItem, value } = useSelectState()

  return (
    <Container label='Async button select without search input inside dropdown'>
      <ButtonAsyncSelectComponent
        Control={ButtonSelectControl}
        EntityIcon={ServiceRequestIcon}
        controlProps={{
          contentProps: {
            placeholderProps: {
              text: 'Select an option',
            },
          },
        }}
        getData={getRequestListLight}
        listProps={{
          Header: null,
        }}
        style={{ width: 240 }}
        toPreparedItems={toRequestAsyncSelectItems}
        value={value}
        onClear={handleClear}
        onSelectItem={handleSelectItem}
      />
    </Container>
  )
}

export default ButtonAsyncSelect
